<section class="container-fluid px-0">
  <div class="row">
    <div class="col-12">
      <form class="container-style mb-2" [formGroup]="formLogs">
        <div class="row">
          <div class="d-flex justify-content-between mb-1 headers-container">
            <div class="filter-name"><b>Filtros</b></div>
          </div>
        </div>
        <div class="row">
          <div class="col filter-date">
            <app-custom-datepicker formControlName="dateInitial" [labelText]="'Fecha Ini.'" [recovery]="true"
              [required]="true"></app-custom-datepicker>
          </div>
          <div class="col filter-date">
            <app-custom-datepicker formControlName="dateFinal" [labelText]="'Fecha Fin.'" [recovery]="true"
              [required]="true"></app-custom-datepicker>
          </div>
          <div class="col filters">
            <app-custom-input-text formControlName="userName" [labelText]="'Usuario'"></app-custom-input-text>
          </div>
          <div class="col filters">
            <app-custom-input-text formControlName="service" [labelText]="'Servicio'"></app-custom-input-text>
          </div>
          <div class="col filters">
            <app-custom-input-text formControlName="method" [labelText]="'Método'"></app-custom-input-text>
          </div>
          <div class="col filters-message">
            <app-custom-input-text formControlName="message" [labelText]="'Mensaje'"></app-custom-input-text>
          </div>
          <div class="col field-buttons d-flex flex-row align-items-end gap-1">
            <app-custom-button [title]="'Recuperar'" [label]="'Recuperar'" [severity]="'primary'" [variant]="undefined"
              (onClick)="send()"></app-custom-button>
            <app-custom-button [title]="'Limpiar'" [severity]="'secondary'" [icon]="'pi pi-eraser'"
              (onClick)="clear()"></app-custom-button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="custom-table-container" [hidden]="!changeFilters">
    <app-custom-table *ngIf="changeFilters" [headers]="generalHeader" [data]="generalData" [showCheckbox]="false"
      [showButtonAdd]="false" [isFilterPersistent]="false" (onPageChange)="onPageChange($event)"></app-custom-table>
  </div>
</section>